import { useEffect, useState } from "react";
import { TextLoader } from "../../../components/loaders/loaders";
import { RenderMarkdown } from "../../../components/typography/renderMarkdown";

export const Terms = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/assets/policies/terms_of_use.md")
      .then((res) => res.text())
      .then((d) => {
        setContent(d);
        setLoading(false);
      })
      .catch((err) => console.error("Failed to load markdown:", err));
  }, []);

  return (
    <div>
      {loading ? (
        <TextLoader count={16} />
      ) : (
        <RenderMarkdown usePreWrapper={false}>{content}</RenderMarkdown>
      )}
    </div>
  );
};
